import house1 from "./full/DSC7685.webp";
import house2 from "./full/DSC7692.webp";
import house3 from "./full/DSC7702.webp";
import house4 from "./full/domek.webp";
import house5 from "./full/DSC_8866-1.webp";
import house6 from "./full/DSC_8877.webp";
import house7 from "./full/DSC_8882.webp";
import house8 from "./full/domek_wiatr_niedzica1.webp";
import house9 from "./full/domek_wiatr_niedzica2.webp";
import house10 from "./full/domek_woda_niedzica2.webp";
import house11 from "./full/domek_wiatr.webp"
import house12 from "./full/domek_woda_niedzica5.webp";
import house13 from "./full/domek_woda_niedzica6.webp";
import house14 from "./full/domek_woda_niedzica7.webp";
import house15 from "./full/domek_woda_niedzica8.webp";
import house16 from "./full/domek_woda_niedzica9.webp";
import house1Thumb from "./thumb/DSC7685.webp";
import house2Thumb from "./thumb/DSC7692.webp";
import house3Thumb from "./thumb/DSC7702.webp";
import house4Thumb from "./thumb/domek.webp";
import house5Thumb from "./thumb/DSC_8866-1.webp";
import house6Thumb from "./thumb/DSC_8877.webp";
import house7Thumb from "./thumb/DSC_8882.webp";
import house8Thumb from "./thumb/domek_wiatr_niedzica1.webp";
import house9Thumb from "./thumb/domek_wiatr_niedzica2.webp";
import house10Thumb from "./thumb/domek_woda_niedzica2.webp";
import house11Thumb from "./thumb/domek_wiatr.webp"
import house12Thumb from "./thumb/domek_woda_niedzica5.webp";
import house13Thumb from "./thumb/domek_woda_niedzica6.webp";
import house14Thumb from "./thumb/domek_woda_niedzica7.webp";
import house15Thumb from "./thumb/domek_woda_niedzica8.webp";
import house16Thumb from "./thumb/domek_woda_niedzica9.webp";

export const housesImages = [
    { thumb: house1Thumb, full: house1, altKey: "1" },
    { thumb: house2Thumb, full: house2, altKey: "2" },
    { thumb: house3Thumb, full: house3, altKey: "3" },
    { thumb: house4Thumb, full: house4, altKey: "4" },
    { thumb: house5Thumb, full: house5, altKey: "5" },
    { thumb: house6Thumb, full: house6, altKey: "6" },
    { thumb: house7Thumb, full: house7, altKey: "7" },
    { thumb: house8Thumb, full: house8, altKey: "8" },
    { thumb: house9Thumb, full: house9, altKey: "9" },
    { thumb: house10Thumb, full: house10, altKey: "10" },
    { thumb: house11Thumb, full: house11, altKey: "11" },
    { thumb: house12Thumb, full: house12, altKey: "12" },
    { thumb: house13Thumb, full: house13, altKey: "13" },
    { thumb: house14Thumb, full: house14, altKey: "14" },
    { thumb: house15Thumb, full: house15, altKey: "15" },
    { thumb: house16Thumb, full: house16, altKey: "16" }
];